<template>
  <v-container class="ma-0 pa-0">
    <v-form ref="form" v-model="valid" lazy-validation>
      <h1>{{$t('labels.email')}}</h1>
      <p>{{$t('application.email.info')}}</p>

      <v-text-field
        ref="email"
        v-shortkey="['enter']"
        @shortkey.native="nextStep"
        v-model="email"
        placeholder="pia.karlsson@gmail.com"
        prepend-icon="$sl-email"
        :rules="[rules.required, rules.email]"
      ></v-text-field>
      <NextButton
        class="mt-3"
        @enter="nextStep"
        :isEnterSubmit="true"
        @click="nextStep"
        :isDisabled="isImitatingUser()"
      >{{$t('labels.confirmEmail')}}</NextButton>
    </v-form>
  </v-container>
</template>

<script>
// Entryform for unknown user to become a apprentice
import API from '@/services/api.js'
import {mapActions, mapGetters} from 'vuex'
import pick from 'lodash/pick'
import omit from 'lodash/omit'
import {RulesMixin} from '@/components/mixins'
import NextButton from '@/components/Common/NextButton'
// import BottomNav from '@/components/Application/BottomNav'

// @group Registration
// Styled Email component
export default {
  name: 'Email',

  mixins: [RulesMixin],

  components: {NextButton},

  data: () => ({
    email: '',
    valid: true
  }),

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isImitatingUser'])
  },

  created() {
    this.email = this.currentUser.email
  },

  watch: {
    'currentUser.email': function (newVal, oldVal) {
      this.email = this.currentUser.email
    }
  },

  methods: {
    /**
     * @vuese
     * Used to go to the next step is form is valid and verify email
     * @arg The argument is an integer representing application  id and params are the selected fields
     */
    nextStep() {
      if (!this.$refs.form.validate()) {
        return this.$events.fire('showError', this.$t('errors.form-validation'))
      }
      API.verifyEmail({data: {email: this.email}})
        .then(response => {
          // Fire goToStep number 3
          // @arg The argument is a string representing email
          this.$emit('goToStep', {step: 3, email: this.email})
        })
        .catch(error => {
          this.$events.fire('showError', this.$t('errors.save-failure'))
          console.log('There was an error:', error)
        })
    }
  }
}
</script>

<style scoped>
</style>